export const styles = {
  container: {
    marginTop: '60px',
  },
  wrapper: {
    flexDirection: [null, 'column', 'row'],
    alignItems: 'flex-start',
    gap: [null, 5, 4, 5, 6],
    justifyContent: 'stretch',
  },
};

export const cardStyles = {
  container: {
    flexDirection: 'column',
    alignItems: 'start',
    backgroundColor: '#fff',
    textAlign: 'start',
    border: '1px solid',
    borderColor: 'gray300',
    width: '100%',
    alignSelf: 'stretch',
    borderRadius: '15px',
    px: [null, 4, null, null, 7],
    py: [null, 6, null, null, 9],
  },

  infoText: {
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: 'primary700',
    mt: 1,
  },
};

export const getStylesByVariant = (variant) => {
  switch (variant) {
    case 'blue':
      return {
        container: {
          backgroundColor: '#F5FBFF',
          borderColor: '#026AA2',
          boxShadow: `0px 4px 6px -2px #165A8B08, 0px 12px 16px -4px #163E8B26`,
        },
        infoText: {
          fontWeight: 500,
          color: '#026AA2',
        },
      };
    case 'yellow':
      return {
        container: {
          backgroundColor: '#FEFBE8',
          borderColor: '#A15C07',
          boxShadow: `0px 4px 6px -2px #8B781608, 0px 12px 16px -4px #8B781626`,
        },
        infoText: {
          fontWeight: 500,
          color: '#A15C07',
        },
      };
    case 'purple':
      return {
        container: {
          backgroundColor: '#FDF4FF',
          borderColor: '#66168B',
          boxShadow: `0px 4px 6px -2px #81539608, 0px 12px 16px -4px #81539626`,
        },
        infoText: {
          fontWeight: 500,
          color: '#66168B',
        },
      };
    default: {
      return {
        container: {},
        infoText: {},
      };
    }
  }
};
